import {
    ConnectedProps,
    connectTicketDisplayCardContentSwitcher,
} from './connectTicketDisplayCardContentSwitcher';
import TicketDisplayCardContentSwitcher, {
    TicketDisplayCardContentSwitcherProps,
} from './TicketDisplayCardContentSwitcher';

export type ConnectedCartSummaryProps = Omit<
    TicketDisplayCardContentSwitcherProps,
    keyof ConnectedProps
>;
export default connectTicketDisplayCardContentSwitcher(
    TicketDisplayCardContentSwitcher,
);
